/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PublicationIncludeFilterItems } from './publicationIncludeFilterItems';
import { PublicationScopeFilter } from './publicationScopeFilter';


export interface PublicationIncludeFilterInner { 
    relation?: PublicationIncludeFilterInner.RelationEnum;
    scope?: PublicationScopeFilter;
}
export namespace PublicationIncludeFilterInner {
    export type RelationEnum = 'publicationTypes' | 'businessUnits' | 'companies' | 'users' | 'publicationDetails' | 'interactions' | 'cities';
    export const RelationEnum = {
        PublicationTypes: 'publicationTypes' as RelationEnum,
        BusinessUnits: 'businessUnits' as RelationEnum,
        Companies: 'companies' as RelationEnum,
        Users: 'users' as RelationEnum,
        PublicationDetails: 'publicationDetails' as RelationEnum,
        Interactions: 'interactions' as RelationEnum,
        Cities: 'cities' as RelationEnum
    };
}


